import { Button, Col, Modal, Row, Table } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { OnboardingStepProps, userTableColumns } from "..";
import { InviteUserModel } from "../../../../models/onboarding/onboarding";
import { DeleteIcon, EditIcon } from "../../../atoms/icon";
import AddUserModal from "./add-user-modal";
import "./add-users.scss";


export default function AddUsers(props: OnboardingStepProps) {

    const { t } = useTranslation();
    const [modalVisible, setModalVisible] = useState(false);
    const [user, setUser] = useState<InviteUserModel>();

    const columns = [
        ...userTableColumns,
        {
            title: t("Onboarding.lbAction"),
            dataIndex: 'action',
            key: 'action',
            render: (text: string, record: any) => (<div className="action">
                <Button type="text" shape="circle" onClick={() => { edit(record) }}>
                    <EditIcon />
                </Button>
                <Button type="text" shape="circle" onClick={() => confirmDelete(record.username)}>
                    <DeleteIcon />
                </Button>
            </div>)
        }
    ];

    const addNew = () => {
        setUser({});
        setModalVisible(true);
    }

    const edit = (record: InviteUserModel) => {
        setUser(record);
        setModalVisible(true);
    }

    const confirmDelete = (username: string) => {
        Modal.confirm({
            content: 'Do you want to delete this user?',
            onOk: () => deleteRecord(username),
            icon: '',
            width: 304
        });
    }

    const deleteRecord = (username: string) => {
        if (props.deleteUser) {
            props.deleteUser(username);
        }
    }

    const save = (record: InviteUserModel) => {

        if (record.username) {
            if (props.updateUser) {
                props.updateUser(record).then(() => {
                    setModalVisible(false);
                });
            }
        } else {
            if (props.addUser) {
                props.addUser(record).then(() => {
                    setModalVisible(false);
                });
            }
        }
    }

    return (
        <div className="section-wrapper add-users-wrapper">
            <div className="table-wrapper">
                <Row>
                    <Col sm={24} className='table-header'>
                        <label>
                            {t("Onboarding.lbAllCorporateUsers")}
                        </label>
                        <Button type="text" onClick={addNew}>
                            + {t("Onboarding.btnNewUser")}
                        </Button>
                    </Col>
                </Row>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Table
                            dataSource={props.users}
                            columns={columns} rowKey="email" />
                    </Col>
                </Row>
            </div>

            <AddUserModal
                useRoles={props.useRoles}
                visible={modalVisible}
                onOK={save}
                onCancle={() => setModalVisible(false)}
                data={user} />
        </div>
    )
}
